export default __webpack_public_path__ + "static/media/doorscratchmiddle.4d33c597.jpg";